import Link from 'next/link'

import { recordGA4Event } from '@components/services/analytics/ga4'
import { useUI } from '@components/ui/context'
import { GENERAL_ITEM_IN_CART } from '@components/utils/textVariables'
import { getCurrentPage, openNewCartPage } from '@framework/utils/app-util'
import router from 'next/router'
import { CartIcon } from '@components/icons'

interface IWishlistHeader {
  data: Array<any>
  previousPath: string
}

const WishlistHeader = (props: IWishlistHeader) => {
  const { data, previousPath } = props
  const { openCart, cartItems } = useUI()

  const backWishlistGAEvent = () => {
    const currentPage = getCurrentPage()
    if (typeof window != 'undefined') {
      recordGA4Event(window, 'back_button', {
        current_page: currentPage,
        previous_page: previousPath,
      })
    }
  }

  return (
    <div className="sticky top-0 z-50 px-4 py-4 mb-4 bg-white border-b shadow-sm mob-header sm:hidden">
      <div className="flex items-center justify-between">
        <h3 className="text-xl font-semibold text-primary">
          <span
            className="mr-2 leading-none"
            onClick={() => {
              // router.back()
              router.replace(
                {
                  pathname: '/my-account',
                },
                '/my-account',
                {
                  shallow: true,
                  scroll: false,
                }
              )
              backWishlistGAEvent()
            }}
            role="button"
            tabIndex={0}
          >
            <i className="sprite-icon sprite-left-arrow mr-2" />
          </span>
          Wishlist
          {data?.length > 0 ? (
            <>
              <span className="ml-1 text-sm text-brown-light">
                {data?.length} items
              </span>
            </>
          ) : (
            <>
              <span className="ml-1 text-sm text-brown-light"> Empty</span>
            </>
          )}
        </h3>
        <div className="flow-root w-10 sm:w-12">
          <button
            className="relative mt-1 flex flex-col items-center justify-center grid-cols-1 mx-auto text-center group align-center"
            onClick={() => {
              openNewCartPage(openCart, 'cart_icon')
            }}
          >
            {/* <i className="sprite-icon sprite-cart" /> */}
            <CartIcon />
            {cartItems?.lineItems?.length > 0 && (
              <span
                className="absolute w-4 h-4 ml-2 text-xs font-medium text-center text-white rounded-full bg-orange"
                style={{ top: '-0.3rem', right: '-0.4rem' }}
              >
                {cartItems?.lineItems?.length}
              </span>
            )}
            <span className="sr-only">{GENERAL_ITEM_IN_CART}</span>
          </button>
        </div>
      </div>
    </div>
  )
}

export default WishlistHeader
